import CheckBoxIconField from './component'

export default CheckBoxIconField
